import isNamesListSite from 'helpers/isNamesListSite';

export const ZOHO_SUPPORT_ID = 'zohodeskasapscript';

const CHAPTERBUILDER_WIDGET_ID = '1076712000000539093';
const NAMESLIST_WIDGET_ID = '1076712000001708028';

export default function initializeZohoSupport() {
  // Provided Zoho script logic
  var d = document;
  var s = d.createElement('script');
  s.type = 'text/javascript';
  s.id = ZOHO_SUPPORT_ID;
  s.defer = true;
  s.nonce = '';
  const widget_id = isNamesListSite()
    ? NAMESLIST_WIDGET_ID
    : CHAPTERBUILDER_WIDGET_ID;
  s.src = `https://desk.zoho.com/portal/api/web/asapApp/${widget_id}?orgId=876064420`;
  var t = d.getElementsByTagName('script')[0];
  if (t && t.parentNode) {
    t.parentNode.insertBefore(s, t);
  } else if (d.body) {
    d.body.appendChild(s);
  }
  // Async ready function
  (window as any).ZohoDeskAsapReady = function(cb: any) {
    var e = ((window as any).ZohoDeskAsap__asyncalls =
      (window as any).ZohoDeskAsap__asyncalls || []);
    if ((window as any).ZohoDeskAsapReadyStatus) {
      if (cb) e.push(cb);
      e.forEach((fn: any) => fn && fn());
      (window as any).ZohoDeskAsap__asyncalls = null;
    } else if (cb) {
      e.push(cb);
    }
  };
}
